import React, { Component } from "react";
import { Form, Row, Col, FormGroup, Label, Input } from "reactstrap";
import FormComponent from "../../../../common/FormComponent";
import {
  Validator,
  submitValidator,
  refresh,
  errors,
  valid,
} from "../../../../common/Validator";
import DateFns from "date-fns";



import { withRouter } from "react-router-dom";

import Notifier from "../../../aside/Notifier";
import ErrorNotifier from "../../../aside/ErrorNotifier";
import axios from "axios";
import { API_CANDIDATE,RS_API } from "../../../../utils/config";
import Button from "@material-ui/core/Button";

import { getProfileInfo} from "../../../../redux/action/profileInfoAction"

import { connect } from "react-redux";

// import { KeyboardReturnTwoTone } from "@material-ui/icons";

/**
 * UpdateEducational Component for updating the educational details.
 */

 let isCandi = true;
class UpdateEducationalDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      candidateQualification: this.props.updateDataProp
        ? this.props.updateDataProp.candQual
        : "",
      candidateSpecicification: this.props.updateDataProp
        ? this.props.updateDataProp.candSpeci
        : "",
      instiName: this.props.updateDataProp
        ? this.props.updateDataProp.instiName
        : "",
      instituteLocation: this.props.updateDataProp
        ? this.props.updateDataProp.instiLocation
        : "",
      fromDate: this.props.updateDataProp
        ? DateFns.format(this.props.updateDataProp.startDate, "YYYY-MM-DD")
        : "",
      toDate: this.props.updateDataProp
        ?  DateFns.format(this.props.updateDataProp.endDate, "YYYY-MM-DD")
        : "",
      noOfYears: this.props.updateDataProp
        ? this.props.updateDataProp.noOfYears
        : "",
      grade: this.props.updateDataProp ? this.props.updateDataProp.grade : "",
      todateback: this.props.updateDataProp
        ? this.props.updateDataProp.organizationName
        : "",
      fromdateback: this.props.updateDataProp
        ? this.props.updateDataProp.organizationName
        : "",
      percentage: this.props.updateDataProp
        ? this.props.updateDataProp.precentage
        : "",
        
      candiError: "",
      dateError: "",
      errorYear:"",
      toErrorYear:"",
      isPercentError:"",
      buttonAction:false,
      id: this.props.updateDataProp ? this.props.updateDataProp.id : undefined, 
      message: "",
      error: "",
      getGrade:[],
      getQualificationData:[]
    };
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onUpdate = this.onUpdate.bind(this);
    this.onPercentChange = this.onPercentChange.bind(this)
    this.dateToChange = this.dateToChange.bind(this);

    this.OnCandiChange = this.OnCandiChange.bind(this);
    this.dateOnChange = this.dateOnChange.bind(this);
    this.getQualification = this.getQualification.bind(this)
  }

  // common onchange function 

  onChange(e) {
    Validator(e.target);
    this.setState({
      [e.target.name]: e.target.value,
      buttonAction:false
    });
    console.log(e.target.value);
  }

  // onchange function for percentage
  onPercentChange(e){
    this.setState({
      buttonAction:false
    })
    console.log(e.target.value)
    var x = e.target.value;

    if (isNaN(x) || x < 0 || x > 100) {
       this.setState({
         isPercentError:"percentage not valid",
         buttonAction:false
       })
    }
    else{
      this.setState({
        percentage:e.target.value,
        isPercentError:""
      })
    }

  }

  // onchange function for candidate
  OnCandiChange(e) {
    this.setState({
      candidateQualification: e.target.value,
      candiError: "",
      buttonAction:false
    });
  
  }





 // update function by clicking update button
  onUpdate(e) {
  
    e.preventDefault();
    submitValidator(e.target);
    let dateFrom = DateFns.format(this.state.fromDate, "YYYY-MM-DD")
    let dateTo = DateFns.format(this.state.toDate, "YYYY-MM-DD")
   
    let data = {
      id: this.state.id,
      canInfoId:this.props.profile.data.id,
      candQual: this.state.candidateQualification,
      candSpeci: this.state.candidateSpecicification,
      precentage: this.state.percentage,
      instiName: this.state.instiName,
      instiLocation: this.state.instituteLocation,
      startDate: dateFrom,
      endDate: dateTo,
      noOfYears: Number(this.state.noOfYears),
      grade: this.state.grade,
    };
    this.setState({
      buttonAction:true 
     })

    if (valid && !this.state.dateError && !this.statetoErrorYear &&
      !this.state.errorYear) {
      axios
        .put(`${API_CANDIDATE}/v1/api/can-education`, data, {
          withCredentials: true,
        })
        .then((res) => {
          console.log(res);
          if (res.data.ok) {
            this.setState({
              message: "Updated successfully ",
            });
          }
          setTimeout(() => {
            this.setState({
              message: "",
            });
            this.props.back();
          }, 2000);
        })
        .catch((err) => {
          if (err.response &&!err.response.data.statusCode === 403) {
            this.setState({
              error:err.response.data.message
            })
              setTimeout(() => {
                this.setState({
                  error:""
                })
              }, 2000);
            } 
            else if (err.response && err.response.data.statusCode === 403) {
           this.setState({
            error:err.response.data.message
            })
             setTimeout(() => {
                this.setState({
                  error: "",
                });
            this.props.history.push("/signin");
               }, 2000);
            }
        });
    } else {
      this.setState({
        error: "Enter all mandatory fields",
      });
      setTimeout(() => {
        this.setState({
          error: "",
        });
      }, 2000);
    }
  }
 // submit function by clicking submit button
  onSubmit(e) {
    
    e.preventDefault();
    if (!this.state.candidateQualification) {
     this.setState({
        candiError: "This field is mandatory",
      });

      isCandi = false;
     
    } else  {
    
      this.setState({
        candiError: "",
      });
      isCandi = true;
   
      console.log(isCandi)
    }
    submitValidator(e.target);
    console.log(errors)

    let dateFrom = DateFns.format(this.state.fromDate, "YYYY-MM-DD")
    let dateTo = DateFns.format(this.state.toDate, "YYYY-MM-DD")
  let data = {
      canInfoId:this.props.profile.data.id,
      candQual: this.state.candidateQualification,
      candSpeci: this.state.candidateSpecicification,
      precentage:this.state.percentage,
      instiName: this.state.instiName,
      instiLocation: this.state.instituteLocation,
      startDate: dateFrom,
      endDate: dateTo,
      noOfYears: Number(this.state.noOfYears),
      grade: this.state.grade,
    };
  

   
    this.setState({
     buttonAction:true 
    })
   
   

    if (valid && isCandi && !this.state.dateError && !this.statetoErrorYear &&
      !this.state.errorYear) {
      axios
        .post(`${API_CANDIDATE}/v1/api/can-education`, data, {
          withCredentials: true,
        })
        .then((res) => {
          console.log(res);
          if (res.data.ok) {
            this.setState({
              message: "successfully created",
              // buttonAction:false
            });
            // this.props.back();
          }
          setTimeout(() => {
            this.setState({
              message: "",
            });
            this.props.back();
          }, 1000);
        })
        .catch((err) => {
          if (err.response &&!err.response.data.statusCode === 403) {
            this.setState({
              error:err.response.data.message
            })
              setTimeout(() => {
                this.setState({
                  error:""
                })
              }, 2000);
            } 
            else if (err.response && err.response.data.statusCode === 403) {
           this.setState({
            error:err.response.data.message
            })
             setTimeout(() => {
                this.setState({
                  error: "",
                });
            this.props.history.push("/signin");
               }, 2000);
            }
        });
    } else {
      this.setState({
        error: "Enter all mandatory fields",
      });
      setTimeout(() => {
        this.setState({
          error: "",
        });
      }, 2000);
    }
  }

  // onChange function for date
  dateToChange(e) {
    Validator(e.target);
    let newdate = new Date(e.target.value);

    this.setState({
      endDate: e.target.value,
      todateback: newdate,
    });
  }


  // date validation
  dateOnChange(e) {
    if (e.target.name === "fromDate") {

      this.setState({
        toDate: "",
        buttonAction:false
      });
      errors.fromDate = "";


      let date = new Date(e.target.value);
      let dateYear = date.getFullYear();

      if ((dateYear.toString().length < 4 || dateYear.toString().length > 4)|| (dateYear > new Date(Date.now()).getFullYear()) )  {
        this.setState({
          errorYear: "please enter valid date",
          buttonAction:false
        });
      } else {
        this.setState({
          errorYear: "",
          buttonAction:false
        });
      }
    }
    if (e.target.name === "toDate") {

      let dateTo = new Date(e.target.value);
      let dateYearTo = dateTo.getFullYear();

      if (
        dateYearTo.toString().length < 4 ||
        dateYearTo.toString().length > 4 ||
        dateYearTo > new Date(Date.now()).getFullYear()
      ) {
        this.setState({
          toErrorYear: "please enter valid date",
          dateError: "",
          buttonAction:false
        });
      } else {
        this.setState({
          toErrorYear: "",
          buttonAction:false
        });
      }

      if (
        Date.parse(e.target.value) < Date.parse(this.state.fromDate) ||
        !this.state.fromDate
      ) {
        this.setState({
          [e.target.name]: e.target.value,
          dateError: "EndDate must be greater than or equal to StartDate",
          toErrorYear: "",
        });

        errors.toDate = "";
      } else {
        this.setState({
          [e.target.name]: e.target.value,
          dateError: "",
        });
        this.noOfDaysYears(e.target.value);
        errors.toDate = "";
      }
    } else {
      this.setState({
        [e.target.name]: e.target.value,
      });
      errors.fromDate = "";
    }
  }



// calculation number of years experience 
  noOfDaysYears(endDate) {
  
    let date1 = new Date(this.state.fromDate);
    let date2 = new Date(endDate);

    let differenceTime = Math.abs(date2 - date1) 
    var day = 1000 * 60 * 60 * 24;

    let days = differenceTime / day
    let years = days / 365.25;
    let months = days / 30.427

    if (years.toString().charAt(0) === "0") {
      if (months.toString().charAt(0) === "0") {
       this.setState({
          noOfYears: 0.0
        });
      }
      else{
        this.setState({
          noOfYears: 0.0
        });
      }
    } 
    else {
      
       this.setState({
        noOfYears: `${ years.toFixed(1)} `
      });
    }

 
  }
   // get dynamic grade form rs
  getGradeData() {
    axios
      .get(`${RS_API}/v1/api/can-qualification-grade/can`, { withCredentials: true })
      .then((res) => {
        console.log(res);
        this.setState({
          getGrade: res.data,
        });
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  // get dynamic qualification form rs

  getQualification() {
    axios
      .get(`${RS_API}/v1/api/can-qualification/can`, { withCredentials: true })
      .then((res) => {
        console.log(res);
        this.setState({
          getQualificationData: res.data,
        });
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  componentDidMount() {
    this.getGradeData();
    this.getQualification()
    this.props.getProfileInfo()

    refresh();
    this.setState({
      message: "",
      error: "",
    });
  }

  render() {
    console.log(this.state.errorYear)
    const {
      candidateQualification,
      candidateSpecicification,
      instiName,
      instituteLocation,
      percentage,
      fromDate,
      toDate,
      noOfYears,
      grade,
      message,
      error,
    } = this.state;

    return (
      <>
         {/* applied ternary operator for checking whether it is update or submit form */}
        {!this.props.updateDataProp ? (
          <div style={{ paddingLeft: "2.5rem" }}>
            <i
              className="material-icons cancel-button pointer"
              onClick={this.props.back}
            >
              cancel
            </i>
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "24px",
                  fontWeight: "bold",
                  paddingTop: "0.5rem",
                }}
              >
                <span> Academic Details</span>
              </div>
              <div>
                <Form onSubmit={this.onSubmit} className="p-3" noValidate>
                  <Row>
                    <Col>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginTop: "8px",
                        }}
                      >
                        <span style={{ fontSize: "17px", fontWeight: "bold" }}>
                          Qualification
                        </span>
                        <Input
                          tabIndex="1"
                          style={{ height: "50px", marginTop: "10px" }}
                          type="select"
                          name="candidateQualification"
                          className="form-control-sm"
                          value={candidateQualification}
                          onChange={this.OnCandiChange}
                          // placeholder="Skill Group"
                          required={true}
                        >
                       
                           <option value="" hidden>
                                Select...
                              </option>
                              {this.state.getQualificationData.map((item) => {
                                return (
                                  <option
                                    key={item.id}
                                    value={item.qualifictiontype}
                                  >
                                    {item.qualifictiontype}
                                  </option>
                                );
                              })}
                       
                        </Input>
                        <span style={{ color: "red", fontSize: "12px" }}>
                          {this.state.candiError}
                        </span>
                      </div>
                      <FormComponent
                       index="3"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Institute Name"
                        type="textarea"
                        name="instiName"
                        inputClass="form-control-sm"
                        value={instiName}
                        change={this.onChange}
                        required={true}
                        minlength="2"
                        maxlength="60"
                      />
                      <FormComponent
                        index="5"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Start Date"
                        type="date"
                        name="fromDate"
                        // max={moment().format("YYYY-MM-DD")}
                        inputClass="form-control-sm"
                        value={fromDate}
                        change={this.dateOnChange}
                        required={true}
                      />
                      <span style={{ color: "red", fontSize: "11px" }}>
                        {this.state.errorYear}
                      </span>

                      <div style={{ display: "flex", maxWidth: "90%" }}>
                        <FormComponent
                         index="7"
                          style={{
                            height: "50px",
                            marginTop: "10px",
                            maxWidth: "150px",
                          }}
                          labelClass="bold label-sm"
                          label="Percentage"
                          type="number"
                          name="percentage"
                          inputClass="form-control-sm"
                          value={percentage}
                            change={this.onPercentChange}
                          required={true}
                        />
                        <div style={{  }}>
                          <FormGroup>
                            <Label style={{ marginLeft: "2rem",}}   className="bold label-sm">
                              Grade
                            </Label>
                            <Input
                             tabIndex="8"
                              style={{
                                height: "50px",
                                maxWidth: "150px",
                                marginTop: "0.8rem",
                                marginLeft: "2rem",
                              }}
                              type="select"
                              name="grade"
                              className="form-control-sm"
                              value={grade}
                              onChange={this.onChange}
                              placeholder="grade"
                              required={true}
                            >
                              <option value="" hidden>
                                Select...
                              </option>
                              {this.state.getGrade.map((item) => {
                                return (
                                  <option
                                    key={item.id}
                                    value={item.gradeName}
                                  >
                                    {item.gradeName}
                                  </option>
                                );
                              })}
                            </Input>
                            {errors.grade && (
                              <span style={{color:"red"}} className="error">
                                {errors.grade}
                              </span>
                            )}
                          </FormGroup>
                       
                        </div>
                      </div>
                    </Col>
                    <Col>
                      <FormComponent
                       index="2"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Specialization"
                        type="textarea"
                        name="candidateSpecicification"
                        inputClass="form-control-sm"
                        value={candidateSpecicification}
                        change={this.onChange}
                        required={true}
                        minlength="2"
                        maxlength="60"
                      />
                      <FormComponent
                       index="4"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Institute Address"
                        type="textarea"
                        name="instituteLocation"
                        inputClass="form-control-sm"
                        value={instituteLocation}
                        change={this.onChange}
                        required={true}
                        minlength="2"
                        maxlength="200"
                      />

                      <FormComponent
                       index="6"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="End Date"
                        type="date"
                        name="toDate"
                        inputClass="form-control-sm"
                        value={toDate}
                        change={this.dateOnChange}
                        required={true}
                        min={this.state.fromDate}
                      />
                      <span style={{ color: "red", fontSize: "11px" }}>
                        {this.state.dateError}
                      </span>
                      <span style={{ color: "red", fontSize: "11px" }}>
                        {this.state.toErrorYear}
                      </span>

                      <FormComponent
                       index="9"
                        style={{ marginTop: "10px", height: "50px" }}
                        labelClass="bold label-sm"
                        label="Number Of Years "
                        name="noOfYears"
                        type="textarea"
                        inputClass="form-control-sm"
                        value={noOfYears}
                        required={true}
                      />
                    </Col>
                  </Row>

                  <div className="center">
                    <Button
                      tabIndex="10"
                      disabled={this.state.buttonAction}
                      type="submit"
                      style={{
                        background: "#0984e3",
                        marginTop: "30px",
                        color: "white",
                      }}
                      className="btn login-button white-text"
                    >
                      Submit
                    </Button>
                  </div>
                </Form>

                {message && <Notifier message={message} />}
                {error && <ErrorNotifier message={error} />}
              </div>
            </div>
          </div>
        ) : (
          <div>
            <i
              className="material-icons cancel-button pointer"
              onClick={this.props.back}
            >
              cancel
            </i>
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "24px",
                  fontWeight: "bold",
                  paddingTop: "0.5rem",
                }}
              >
                <span> Academic Details</span>
              </div>
              <div>
                <Form onSubmit={this.onUpdate} className="p-3" noValidate>
                  <Row>
                  <Col>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginTop: "8px",
                        }}
                      >
                        <span style={{ fontSize: "13px", fontWeight: "bold" }}>
                          Qualification
                        </span>
                        <Input
                          tabIndex="1"
                          style={{ height: "50px", marginTop: "10px" }}
                          type="select"
                          name="candidateQualification"
                          className="form-control-sm"
                          value={candidateQualification}
                          onChange={this.OnCandiChange}
                          // placeholder="Skill Group"
                          required={true}
                        >
                       
                           <option value="" hidden>
                                Select...
                              </option>
                              {this.state.getQualificationData.map((item) => {
                                return (
                                  <option
                                    key={item.id}
                                    value={item.qualifictiontype}
                                  >
                                    {item.qualifictiontype}
                                  </option>
                                );
                              })}
                       
                        </Input>
                        <span style={{ color: "red", fontSize: "12px" }}>
                          {this.state.candiError}
                        </span>
                      </div>
                      <FormComponent
                       index="3"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Institute Name"
                        type="textarea"
                        name="instiName"
                        inputClass="form-control-sm"
                        value={instiName}
                        change={this.onChange}
                        required={true}
                        minlength="2"
                        maxlength="60"
                      />
                      <FormComponent
                        index="5"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Start Date"
                        type="date"
                        name="fromDate"
                        // max={moment().format("YYYY-MM-DD")}
                        inputClass="form-control-sm"
                        value={fromDate}
                        change={this.dateOnChange}
                        required={true}
                      />
                      <span style={{ color: "red", fontSize: "11px" }}>
                        {this.state.errorYear}
                      </span>

                      <div style={{ display: "flex", maxWidth: "90%" }}>
                        <FormComponent
                         index="7"
                          style={{
                            height: "50px",
                            marginTop: "10px",
                            maxWidth: "150px",
                          }}
                          labelClass="bold label-sm"
                          label="Percentage"
                          type="number"
                          name="percentage"
                          inputClass="form-control-sm"
                          value={percentage}
                            change={this.onPercentChange}
                          required={true}
                        />
                        <div style={{  }}>
                          <FormGroup>
                            <Label style={{ marginLeft: "2rem",}}   className="bold label-sm">
                              Grade
                            </Label>
                            <Input
                             tabIndex="8"
                              style={{
                                height: "50px",
                                maxWidth: "150px",
                                marginTop: "0.8rem",
                                marginLeft: "2rem",
                              }}
                              type="select"
                              name="grade"
                              className="form-control-sm"
                              value={grade}
                              onChange={this.onChange}
                              placeholder="grade"
                              required={true}
                            >
                              <option value="" hidden>
                                Select...
                              </option>
                              {this.state.getGrade.map((item) => {
                                return (
                                  <option
                                    key={item.id}
                                    value={item.gradeName}
                                  >
                                    {item.gradeName}
                                  </option>
                                );
                              })}
                            </Input>
                            {errors.grade && (
                              <span style={{color:"red"}}  className="error">
                                {errors.grade}
                              </span>
                            )}
                          </FormGroup>
                       
                        </div>
                      </div>
                    </Col>
                    <Col>
                      <FormComponent
                       index="2"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Specialization"
                        type="textarea"
                        name="candidateSpecicification"
                        inputClass="form-control-sm"
                        value={candidateSpecicification}
                        change={this.onChange}
                        required={true}
                        minlength="2"
                        maxlength="60"
                      />
                      <FormComponent
                       index="4"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Institute Address"
                        type="textarea"
                        name="instituteLocation"
                        inputClass="form-control-sm"
                        value={instituteLocation}
                        change={this.onChange}
                        required={true}
                        minlength="2"
                        maxlength="200"
                      />

                      <FormComponent
                       index="6"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="End Date"
                        type="date"
                        name="toDate"
                        inputClass="form-control-sm"
                        value={toDate}
                        change={this.dateOnChange}
                        required={true}
                        min={this.state.fromDate}
                      />
                      <span style={{ color: "red", fontSize: "11px" }}>
                        {this.state.dateError}
                      </span>
                      <span style={{ color: "red", fontSize: "11px" }}>
                        {this.state.toErrorYear}
                      </span>

                      <FormComponent
                       index="9"
                        style={{ marginTop: "10px", height: "50px" }}
                        labelClass="bold label-sm"
                        label="Number Of Years "
                        name="noOfYears"
                        type="textarea"
                        inputClass="form-control-sm"
                        value={noOfYears}
                        required={true}
                      />
                    </Col>
                  </Row>
                  <div className="center">
                    <Button
                     tabIndex="10"
                      disabled={this.state.buttonAction}
                      type="submit"
                      style={{
                        background: "#0984e3",
                        marginTop: "30px",
                        color: "white",
                      }}
                      className="btn login-button white-text"
                    >
                      Update
                    </Button>
                  </div>
                </Form>

                {message && <Notifier message={message} />}
                {error && <ErrorNotifier message={error} />}
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}


const mapStateToProps = (state) => ({
  profile: state.profile,
});

export default connect(mapStateToProps,{getProfileInfo})(
  withRouter(UpdateEducationalDetails)
);